import React, { Component } from 'react';

import { Redirect } from 'react-router-dom';

import { StorageHandler } from 'C4';
import { storageKeys } from 'settings';

export default class CheckLogin extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loggedIn: true,
    };
  }

  componentDidMount() {
    StorageHandler.load(storageKeys.user)
      .then(user => this.setState({ loggedIn: user }));
  }

  render() {
    const { loggedIn } = this.state;
    return (
      <div>
        {!loggedIn && <Redirect to="/main/off" />}
      </div>
    );
  }
}
